import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useVoteData } from '../../context/VoteDataContext';
import { usePlayerComparison } from '../../context/PlayerComparisonContext';
import SideNav from '../SideNav/SideNav';
import PlayerComparisonGroup from './PlayerComparisonGroup';
import { Plus } from 'lucide-react';

const PlayerComparison = () => {
  const { user, token, isAuthenticated } = useAuth();
  const { data: voteData, isLoading: isVoteLoading, error: voteError, fetchVoteData } = useVoteData();
  const { 
    comparisonGroups, 
    addComparisonGroup, 
    removeComparisonGroup 
  } = usePlayerComparison();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Fetch vote data once after successful login
  useEffect(() => {
    const t = token && token();
    if (isAuthenticated && t && !voteData) {
      fetchVoteData(t);
    }
  }, [isAuthenticated, token, voteData, fetchVoteData]);

  return (
    <div className="min-h-screen bg-[#020817] text-white">
      {/* Navigation */}
      <SideNav 
        isMobileMenuOpen={isMobileMenuOpen} 
        setIsMobileMenuOpen={setIsMobileMenuOpen} 
      />

      {/* Player Comparison Content */}
      <div className="md:ml-[var(--sidenav-width)] md:transition-[margin-left] md:duration-200 md:ease-out pt-3 md:pt-6 pb-20 md:pb-0">
        {isVoteLoading && (
          <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-3 md:px-6">
            <div className="animate-spin rounded-full h-12 w-12 border-2 border-slate-800 border-t-emerald-400" />
          </div>
        )}
        {voteError && (
          <div className="px-3 md:px-6 pb-6">
            <div className="bg-rose-500/10 border border-rose-500/40 text-rose-300 rounded-xl p-3 text-sm">{voteError}</div>
          </div>
        )}
        {!isVoteLoading && (
          <div className="px-3 md:px-6 pb-6">
            {/* Add New Comparison Button */}
            <div className="mb-3">
              <button
                onClick={addComparisonGroup}
                className="w-full md:w-auto h-10 px-3 text-xs font-mono font-medium rounded-lg border border-slate-700/70 text-slate-300 hover:bg-slate-800/60 hover:text-slate-200 hover:border-slate-600 transition-all flex items-center justify-center md:justify-start gap-2"
                title="Add a new comparison group"
              >
                <Plus className="w-4 h-4" />
                Add New Comparison
              </button>
            </div>

            {/* Comparison Groups */}
            <div className="space-y-4">
              {comparisonGroups.map((group) => (
                <PlayerComparisonGroup
                  key={group.id}
                  groupId={group.id}
                  voteData={voteData}
                  onRemove={comparisonGroups.length > 1 ? removeComparisonGroup : null}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlayerComparison;